<template>
  <div id="ceshi">
    <el-card class="box-card" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading">
      <div slot="header" class="clearfix">
        <span>网站管理&nbsp;/&nbsp;基础信息</span>
        <el-button type="success" @click="handleEdit(1)">添加</el-button>
      </div>
      <div style="margin-bottom: 18px;">
        <el-select v-model="sheng" placeholder="省份" @change="cksheng" style="margin-right: 16px;">
          <el-option v-for="item in shenglist" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="shi" placeholder="城市" @change="ckshi" style="margin-right: 16px;">
          <el-option v-for="item in shilist" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
        <el-table-column prop="cityName" label="所属地区"></el-table-column>
        <el-table-column min-width="20" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(2, scope.row,'agreement:update')"
            >
              <i class="el-icon-edit"></i> 编辑
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row,'agreement:delete')"
            >
              <i class="el-icon-delete"></i> 删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span>共<i class="pagingNum">{{total}}</i> 条</span>
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
      <el-dialog title="基础信息添加/编辑" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <div class="newbox" style="display: flex;justify-content: space-between;">
          <div style="width: 70%;" class="leftcont">
            <p>* ICP备案号</p>
           <el-input placeholder="请输入ICP" v-model="datalist.ICP" clearable></el-input>
            <p>* QQ</p>
           <el-input placeholder="请输入QQ" v-model="datalist.QQ" clearable></el-input>
            <p>* 联系地址</p>
           <el-input placeholder="请输入联系地址" v-model="datalist.address" clearable></el-input>
            <p>* 电子邮件</p>
           <el-input placeholder="请输入电子邮件" v-model="datalist.email" clearable></el-input>
            <p>* 网站</p>
           <el-input placeholder="请输入网站" v-model="datalist.domain" clearable></el-input>
            <p>* 公司名称</p>
           <el-input placeholder="请输入公司名称" v-model="datalist.wxgz" clearable></el-input>
            <p>* 网站名称</p>
           <el-input placeholder="请输入网站名称" v-model="datalist.website" clearable></el-input>
            <p>* 联系电话</p>
           <el-input placeholder="请输入联系电话" v-model="datalist.tel_phone" clearable></el-input>
            <p v-if="stat == 2">* 所属地区</p>
           <el-input v-if="stat == 2" :disabled="true" v-model="datalist.cityName" clearable></el-input>
            <p v-if="stat == 1">* 区域分配</p>
            <el-select
              v-model="datalist.sheng1"
              placeholder="省份"
              style="margin-right: 16px;"
              v-if="stat == 1"
            >
              <el-option
                v-for="item in shenglist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="datalist.shi1"
              placeholder="城市"
              style="margin-right: 16px;"
              v-if="stat == 1"
            >
              <el-option v-for="item in shilist" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <!-- <el-button type="primary" v-if="opbtn('basicData:update')" @click="update"><i class="el-icon-edit"></i>更新</el-button> -->
          </div>
          <div style="width: 26%;">
            <div class="upload1" style="margin-top:20px">
              <el-upload
                class="avatar-uploader"
                :action="URL"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :data="newobj"
                :before-upload="beforeAvatarUpload"
                name="multipartFile"
                :headers="newhead"
              >
                <img v-if="imgurl" :src="imgUrl+imgurl" class="avatar" />
                <p v-else class="loadimg">上传logo</p>
              </el-upload>
            </div>
            <div class="img_size">
              <p>（ 推荐尺寸：230:130 ）</p>
              <p>（ 推荐比例：3:2 ）</p>
            </div>
            <div class="upload1" style="margin-top:20px">
              <el-upload
                class="avatar-uploader"
                :action="URL"
                :show-file-list="false"
                :on-success="handleAvatarSuccess2"
                :before-upload="beforeAvatarUpload"
                name="multipartFile"
                :data="newobj"
                :headers="newhead"
              >
                <img v-if="imgurl2" :src="imgUrl+imgurl2" class="avatar" />
                <p v-else class="loadimg">上传微信二维码</p>
              </el-upload>
            </div>
            <div class="img_size">
              <p>（ 推荐尺寸：230*230 ）</p>
              <p>（ 推荐比例：1:1 ）</p>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="update('basicData:update')">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import Paging from '@/components/Paging';
export default {
  name: "agreement",
  components:{
      Paging
  },
  data() {
    return {
      userdata: {},
      icp: "",
      qq: "",
      city: "",
      email: "",
      inter: "",
      company: "",
      intername: "",
      phone: "",
      datalist: {},
      btn: [],
      imgurl: "",
      imgurl2: "",
      newhead: {
        accessToken: JSON.parse(sessionStorage.getItem("userdata")).token
      },
      ceshi: "",
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      URL: `${this.$Public.URL}/api-r/upload/uploadImg`,
      shi: "",
      sheng: "",
      shenglist: [],
      shilist: [],
      pageNum: 1,
      pageSize: 10,
      areaId: "",
      tableData: [],
      total: 0,
      dialogVisible: false,
      stat: "",
      newobj: { type: 1 }
    };
  },
  computed: {
    data() {
      return tableData;
    }
  },
  created() {
    // 查询基础信息列表
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.$set(this, "userdata", userdata);

    this.begin();

    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem("region"));
    region.forEach(x => {
      if (x.level == 0) {
        this.shenglist.push(x);
        this.sheng = x.id
      }
    });
    if (this.userdata.level == 0) {
      this.$axios
        .post(
          `/api-r/area/getSubordinateAreaList`,
          this.$qs.stringify({ areasId: region[0].id }),
          { headers: { accessToken: this.userdata.token } }
        )
        .then(res => {
          if (res.data.success) {
            this.$set(this, "shilist", res.data.areaListInfoList);
          }
        });
    } else {
      region.forEach(x => {
        if (x.level == 1) {
          this.shilist.push(x);
          this.shi=x.id;
        }
      });
    }
  },
  methods: {
    // 删除
    handleDelete(row) {
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post(
              `/api-r/data/deleteBase/${row.cityId}`,
              {},
              { headers: { accessToken: this.userdata.token } }
            )
            .then(res => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg
                });
                this.begin();
              } else {
                this.$message(res.data, msg);
              }
            });
        })
        .catch(() => {});
    },
    handleClose(done) {
      this.datalist = {};
      this.imgurl = "";
      this.imgurl2 = "";
      this.dialogVisible = false;
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.loadpage();
    },
    handleEdit(stat,row,hint) {
      if(hint&&this.btn.indexOf(hint)==-1){
          return this.$message('抱歉，用户暂无该权限')
      }
      this.stat = stat;
      if (stat == 2) {
        this.$axios
          .post(
            `/api-r/data/getBaseInfo/${row.cityId}`,
            {},
            { headers: { accessToken: this.userdata.token } }
          )
          .then(res => {
            this.fullscreenLoading = false;
            this.ceshi = res.data.hsdbaseList;
            let arr = JSON.parse(res.data.hsdbaseList);
            let newarr = [];
            let obj = {};
            arr.forEach(x => {
              if (x.name == "ICP") {
                Object.assign(obj, { ICP: x.data });
              } else if (x.name == "QQ") {
                Object.assign(obj, { QQ: x.data });
              } else if (x.name == "address") {
                Object.assign(obj, { address: x.data });
              } else if (x.name == "email") {
                Object.assign(obj, { email: x.data });
              } else if (x.name == "domain") {
                Object.assign(obj, { domain: x.data });
              } else if (x.name == "wxgz") {
                Object.assign(obj, { wxgz: x.data });
              } else if (x.name == "website") {
                Object.assign(obj, { website: x.data });
              } else if (x.name == "tel_phone") {
                Object.assign(obj, { tel_phone: x.data });
              } else if (x.name == "logo") {
                Object.assign(obj, { logo: x.data });
              } else if (x.name == "wxsrc") {
                Object.assign(obj, { wxsrc: x.data });
                Object.assign(obj, { cityId: x.cityId });
                Object.assign(obj, { cityName: x.cityName });
              }
            });
            this.imgurl = obj.logo;
            this.imgurl2 = obj.wxsrc;
            this.$set(this, "datalist", obj);
            this.dialogVisible = true;
          });
      } else if (stat == 1) {
        this.dialogVisible = true;
      }
    },
    begin() {
      let data = this.$qs.stringify({
        adminAreasId: this.userdata.areasId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        areaId: this.areaId
      });
      this.$axios
        .post(`/api-r/data/getBaseList`, data, {
          headers: { accessToken: this.userdata.token }
        })
        .then(res => {
          if (res.data.success) {
            this.fullscreenLoading = false;
            this.tableData = res.data.pageInfo.list;
            this.total = res.data.pageInfo.total;
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    cksheng(val) {
      this.$set(this, "shi", "");
      this.areaId = val;
    },
    reset() {
      this.$router.push("/refresh");
    },
    query() {
      this.pageNum = 1;
      this.fullscreenLoading = true;
      this.begin();
    },
    ckshi(val) {
      this.areaId = val;
    },
    handleAvatarSuccess(res, file) {
      this.imgurl = res.url;
      this.datalist.logo = res.url;
    },
    handleAvatarSuccess2(res, file) {
      this.imgurl2 = res.url;
      this.datalist.wxsrc = res.url;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    update(hint) {
      if(hint&&this.btn.indexOf(hint)==-1){
          return this.$message('抱歉，用户暂无该权限')
      }
      let obj = this.datalist;
      if (obj.ICP == "" || obj.ICP == undefined) {
        this.$message("请完善ICP");
        return;
      }
      if (obj.QQ == "" || obj.QQ == undefined) {
        this.$message("请完善QQ");
        return;
      }
      if (obj.address == "" || obj.address == undefined) {
        this.$message("请完善联系地址");
        return;
      }
      if (obj.email == "" || obj.email == undefined) {
        this.$message("请完善电子邮件");
        return;
      }
      if (obj.domain == "" || obj.domain == undefined) {
        this.$message("请完善网站填写");
        return;
      }
      if (obj.wxgz == "" || obj.wxgz == undefined) {
        this.$message("请完善公司名称");
        return;
      }
      if (obj.website == "" || obj.website == undefined) {
        this.$message("请完善网站名称");
        return;
      }
      if (obj.tel_phone == "" || obj.tel_phone == undefined) {
        this.$message("请完善联系电话");
        return;
      }
      if (obj.logo == "" || obj.logo == undefined) {
        this.$message("请上传LOGO");
        return;
      }
      if (obj.wxsrc == "" || obj.wxsrc == undefined) {
        this.$message("请上传微信二维码");
        return;
      }
      let arr = [
        { name: "ICP", data: obj.ICP },
        { name: "QQ", data: obj.QQ },
        { name: "address", data: obj.address },
        { name: "email", data: obj.email },
        { name: "domain", data: obj.domain },
        { name: "wxgz", data: obj.wxgz },
        { name: "website", data: obj.website },
        { name: "tel_phone", data: obj.tel_phone },
        { name: "logo", data: obj.logo },
        { name: "wxsrc", data: obj.wxsrc }
      ];
      if (this.stat == 2) {
        this.fullscreenLoading = true;
        let data = this.$qs.stringify({
          hsdBaseVoList: JSON.stringify(arr),
          cityId: obj.cityId,
          cityName: obj.cityName
        });
        this.$axios
          .post(`/api-r/data/updateBase`, data, {
            headers: { accessToken: this.userdata.token }
          })
          .then(res => {
            this.fullscreenLoading = false;
            if (res.data.success) {
              this.$message({
                type: "success",
                message: res.data.msg
              });
              this.datalist = {};
              this.imgurl = "";
              this.imgurl2 = "";
              // this.$router.push('/refresh')
              this.dialogVisible = false;
              this.begin();
            } else {
              this.$message(res.data.msg);
            }
          });
      } else {
        if (obj.shi1 == undefined) {
          this.$message("请完善所属地区");
          return;
        }
        this.fullscreenLoading = true;
        let arr2 = [];
        let arr1 = [];
        this.shilist.forEach(x => {
          if (x.id == obj.shi1) {
            arr2.push(this.shenglist[0].id, obj.shi1);
            arr1.push(this.shenglist[0].name, x.name);
          }
        });
        let data = this.$qs.stringify({
          hsdBaseVoList: JSON.stringify(arr),
          cityId: arr2.join(","),
          cityName: arr1.join(",")
        });
        this.$axios
          .post(`/api-r/data/addBase`, data, {
            headers: { accessToken: this.userdata.token }
          })
          .then(res => {
            this.fullscreenLoading = false;
            if (res.data.success) {
              this.$message({
                type: "success",
                message: res.data.msg
              });
              this.datalist = {};
              this.imgurl = "";
              this.imgurl2 = "";
              this.dialogVisible = false;
              // this.$router.push('/refresh')
              this.begin();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    }
  }
};
</script>
<style>
#ceshi .newbox .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  /* margin-bottom: 20px; */
}
#ceshi .newbox .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#ceshi .newbox .el-upload {
  width: 100%;
}
#ceshi .newbox .el-input.is-disabled .el-input__inner {
  background: none;
}
/* 暂无数据样式 */
#ceshi .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#ceshi .el-table--border th,
.el-table--border td {
  text-align: center;
}
.el-input__inner{
  margin-top: 0;
}
</style>
<style scoped lang="scss">
.upimg {
  width: 100%;
  text-align: center;
  background-color: #dcdcdc;
  line-height: 30px;
}
.upload1 {
  border: 1px solid #d2d2d2;
  padding: 6px;
}
.upload1 img {
  width: 100%;
}
.leftcont p {
    margin: 18px 0 6px;
}
.loadimg {
  text-align: center;
  background: #ccc;
  line-height: 30px;
  color: #ffff;
  width: 100%;
}
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.img_size {
  font-size: 12px;
  padding: 8px;
}
</style>
